const { api } = require("./api")

const NewNotification = {
  fetchAll(params) {
    return api.get("new-notifications", params);
  },
  fetchByCompany(company_id) {
    return api.get(`new-notifications/company/${company_id}`)
  },
  fetchByUser(user_id, params) {
    return api.get(`new-notifications/user/${user_id}`, params)
  },
  fetchNotViewed() {
    return api.get('new-notifications/count')
  },
  store(params) {
    return api.post("new-notifications", params)
  },
  update(id, params) {
    return api.post(`new-notifications/${id}`, params)
  },
  delete(id) {
    return api.delete(`new-notifications/${id}`)
  },
  setRead(id) {
    return api.put(`new-notifications/set-read/${id}`);
  },
  setViewed(params) {
    return api.put(`new-notifications/set-viewed`, params);
  },
  setAllRead(id) {
    return api.put(`new-notifications/set-all-read/${id}`)
  }
}

export default NewNotification